import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { MantineProvider } from '@mantine/core';

import {
  AppContainer,
  DuckTable,
  Login,
  Pools,
  shadcnTheme,
  Subnets,
  ScanDetail,
  useAuthContext,
} from '@ducks/ui';

import '@mantine/core/styles.css';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, loading } = useAuthContext();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <AppContainer>{children}</AppContainer>;
}

function LoginPage() {
  const navigate = useNavigate();
  
  const handleLoginSuccess = () => {
    navigate('/ducks');
  };
  
  return <Login onLoginSuccess={handleLoginSuccess} />;
}

export function App() {
  const { isAuthenticated, loading } = useAuthContext();

  return (
    <MantineProvider defaultColorScheme="auto" theme={shadcnTheme}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            loading ? (
              <div>Loading...</div>
            ) : isAuthenticated ? (
              <Navigate to="/ducks" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/ducks"
          element={
            <ProtectedRoute>
              <DuckTable />
            </ProtectedRoute>
          }
        />
        <Route
          path="/network/pools"
          element={
            <ProtectedRoute>
              <Pools />
            </ProtectedRoute>
          }
        />
        <Route
          path="/network/subnets"
          element={
            <ProtectedRoute>
              <Subnets />
            </ProtectedRoute>
          }
        />
        <Route
          path="/scans/:scanId"
          element={
            <ProtectedRoute>
              <ScanDetail />
            </ProtectedRoute>
          }
        />
      </Routes>
    </MantineProvider>
  );
}

export default App;
